import apiClient from '@/api/client';

class DictResource {

    constructor () {
        this.client = apiClient;
    }

    eventTypes (params) {
        return this.client.request({
            method: 'get',
            path: '/upyield/v1/dict/event-types',
            params: { limit: -1, ...params },
        });
    }

    timezones () {
        return this.client.request({
            method: 'get',
            path: '/upyield/v1/dict/timezones',
        });
    }

    virtualEventTypes () {
        return this.client.request({
            method: 'get',
            path: '/upyield/v1/dict/virtual-event-types',
        });
    }

    currencies (params) {
        return this.client.request({
            method: 'get',
            path: '/upyield/v1/dict/currencies',
            params: { limit: -1, ...params },
        });
    }

    countries (params) {
        return this.client.request({
            method: 'get',
            path: '/upyield/v1/dict/countries',
            params: { limit: -1, ...params },
        });
    }

    categories (params) {
        return this.client.request({
            method: 'get',
            path: '/upyield/v1/dict/categories',
            params: { limit: -1, ...params },
        });
    }

    regions (params) {
        const limit = params.countries && params.countries.length ? -1 : 500;
        return this.client.request ({
            method: 'get',
            path: '/upyield/v1/dict/regions',
            params: { limit, ...params },
        });
    }

    cities (params) {
        const limit = params.countries && params.countries.length ? -1 : 500;
        return this.client.request ({
            method: 'get',
            path: '/upyield/v1/dict/cities',
            params: { limit, ...params },
        });
    }

    userRoles (params) {
        return this.client.request ({
            method: 'get',
            path: '/upyield/v1/dict/roles',
            params: params,
        });
    }

    offerTags (params) {
        return this.client.request ({
            method: 'get',
            path: '/upyield/v1/dict/offer-tags',
            params: { ...params, tag_group: 'external' },
        });
    }

    offerLabels (params) {
        return this.client.request ({
            method: 'get',
            path: '/upyield/v1/dict/offer-tags',
            params: { ...params, tag_group: 'internal' },
        });
    }

    partnerLabels (params) {
        return this.client.request ({
            method: 'get',
            path: '/upyield/v1/dict/partner-tags',
            params: { ...params, tag_group: 'internal' },
        });
    }

    advertiserLabels (params) {
        return this.client.request ({
            method: 'get',
            path: '/upyield/v1/dict/advertiser-tags',
            params: { ...params, tag_group: 'internal' },
        });
    }

    isps (params) {
        return this.client.request({
            method: 'get',
            path: '/upyield/v1/dict/isp',
            params,
        });
    }

    destinationUrlTrackingParams (params) {
        return this.client.request({
            method: 'get',
            path: '/upyield/v1/dict/destination-url-tracking-params',
            params,
        });
    }

    vettingStrategies () {
        return this.client.request({
            method: 'get',
            path: '/upyield/v1/dict/vetting-strategies',
        });
    }

    landingPages (params) {
        return this.client.request({
            method: 'get',
            path: '/upyield/v1/dict/landing-pages',
            params,
        });
    }

    customTrackingParams (params) {
        return this.client.request({
            method: 'get',
            path: '/upyield/v1/dict/tracking-params',
            params,
        });
    }

    applicationParams (params) {
        return this.client.request({
            method: 'get',
            path: '/upyield/v1/dict/application-params',
            params,
        });
    }

    impressionTrackingParams (params) {
        return this.client.request({
            method: 'get',
            path: '/upyield/v1/dict/impression-tracking-params',
            params,
        });
    }

    kpiControlEventTypes (params) {
        return this.client.request({
            method: 'get',
            path: '/upyield/v1/dict/event-types',
            params,
        });
    }

    capsParams (advertiserId = null) {
        return this.client.request({
            method: 'get',
            path: '/upyield/v1/dict/caps-params',
            params: advertiserId ? { advertiser_id: advertiserId } : {},
        });
    }
}

export default new DictResource;
